import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import TextArea from '../../../common/components/TextArea.js'
import apiverson from '../../../common/apiverson.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {updateReturnOrder} from '../../../redux/actions/data/returnOrders.js'
import {returnOrderSelector} from '../../../redux/selectors/data/returnOrders.js'

const MODAL_FORM = 'add_return_order_comment_modal'

export function showAddReturnOrderCommentModal(referenceID) {
  setForm(MODAL_FORM, {
    referenceID,
    comment: '',
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function close() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export async function addReturnOrderComment() {
  try {
    updateModalForm({isSaving: true})

    const {referenceID, comment} = modalFormSelector(getState())

    const {json} = await apiverson.post(
      `/return_order/${encodeURIComponent(referenceID)}/comment`,
      {comment},
    )

    const {comments} = returnOrderSelector(getState(), {referenceID})

    if (comments) {
      updateReturnOrder(referenceID, {comments: [json, ...comments]})
    }

    showMessageToast('RMA comment was added.')

    close()
  } catch (err) {
    updateModalForm({
      serverError: `Error creating RMA comment: ${
        err.message || err.error_message
      }`,
      isSaving: false,
    })
  }
}

function AddReturnOrderCommentModal({form}) {
  return (
    <ConfirmModal
      title="Add RMA Comment"
      confirmText="Save"
      cancelText="Cancel"
      onConfirm={() => addReturnOrderComment()}
      onCancel={() => close()}
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <ul className="list list--no-style">
        <li className="list__item--form list__item--no-style divider--bottom">
          <div className="fs-01">
            <strong>{form.referenceID}</strong>
          </div>
        </li>
        <li>
          <TextArea
            label="Comment"
            rows="10"
            id="comment"
            value={form.comment}
            onChange={(value) => updateModalForm({comment: value})}
            autoFocus
          />
        </li>
      </ul>
    </ConfirmModal>
  )
}

export default onlyIfForm(AddReturnOrderCommentModal, modalFormSelector)
